<template>
  <main>
    <section class="promo">
      <div class="container">
        <div class="promo__wrap">
          <div class="promo__info">
            <img src="images/logo.svg" alt="logo" class="promo__logo">
            <div class="promo__try">
              <p class="promo__text">Ваши клиенты уже ждут, начните работу прямо сейчас</p>
              <a href="/register" class="promo__btn">Попробовать бесплатно</a>
              <div class="promo__hint">пробный период 7 дней</div>
            </div>
          </div>
          <div class="promo__image-wrap">
            <img src="images/promo-image.jpg" alt="image">
          </div>
        </div>
      </div>
    </section>
    <section class="common-section about" id="about-anchor">
      <div class="container">
        <h2 class="common-section__title">О компании</h2>
        <div class="about__wrap">
          <div class="about__info-wrapper">
            <div class="about__main-slider">
            <!--slides  -->
              <div class="about__slide" v-if="aboutSlideNumber === 0"  >
                <h3 class="about__subtitle">Система онлайн-записи Croinc</h3>
                <p class="about__text">Клиент всегда стоял и стоит на первым месте для каждого бизнеса. Наша задача сделать так чтобы во всех сферах услуг, каждый клиент мог получить наилучшее впечатление о вашем предприятии — от начала записи до ее завершения.
                  Мы строим систему, которая может связать глобально все бизнесы воедино, чтобы клиент мог записаться куда, к кому и когда ему удобно. С вашей помощью, мы каждый день приближаемся к реализации этой задачи!</p>
              </div>
              <div class="about__slide" v-if="aboutSlideNumber === 1"  >
                <div class="about__mobile-info">
                  <h3 class="about__subtitle">Нужен ли мне Croinc?</h3>
                  <p class="about__text">Он-Лайн запись экономит время вашего клиента, повышает его лояльность к вашим услугам, оптимизирует процессы и сокращает расходы на содержание дополнительного персонала.</p>
                </div>
                <div class="about__tabs-wrap">
                  <div class="about__tabs">
                    <a v-on:click="changeSlide(0, 'subAbout')" :class="{'is-active': aboutSubSlideNumber === 0}" class="about__tab-link"><img src="images/e-nails.png" alt=""> Салон красоты</a>
                    <a v-on:click="changeSlide(1, 'subAbout')" :class="{'is-active': aboutSubSlideNumber === 1}" class="about__tab-link"><img src="images/e-fitnes.png" alt=""> Фитнесс</a>
                    <a v-on:click="changeSlide(2, 'subAbout')" :class="{'is-active': aboutSubSlideNumber === 2}" class="about__tab-link"><img src="images/e-shamp.png" alt=""> Ресторан</a>
                    <a v-on:click="changeSlide(3, 'subAbout')" :class="{'is-active': aboutSubSlideNumber === 3}" class="about__tab-link"><img src="images/e-health.png" alt=""> Здоровье</a>
                    <a v-on:click="changeSlide(4, 'subAbout')" :class="{'is-active': aboutSubSlideNumber === 4}" class="about__tab-link"><img src="images/e-auto.png" alt=""> Авто-Бизнес</a>
                  </div>
                  <p class="about__tab-item" v-if="aboutSubSlideNumber === 0">Вы не пропустите ни одного клиента</p>
                  <p class="about__tab-item" v-if="aboutSubSlideNumber === 1">Ваши клиенты с лёгкостью смогут записаться на тренировку</p>
                  <p class="about__tab-item" v-if="aboutSubSlideNumber === 2">В любое время у вас смогут забронировать столик</p>
                  <p class="about__tab-item" v-if="aboutSubSlideNumber === 3">Сделайте запись на консультацию еще проще </p>
                  <p class="about__tab-item" v-if="aboutSubSlideNumber === 4">Дайте клиенту возможность записаться на любую услугу за секунды</p>
                </div>
              </div>
              <div class="about__slide" v-if="aboutSlideNumber === 2">
                <h3 class="about__subtitle">Нам Доверяют</h3>
                <p class="about__text">
                  Город красоты <br> Real Clinic <br> Стомдом
                </p>
              </div>
            </div>
          </div>
          <div class="about__blocks-wrapper" v-show="mediaDesktop">
            <div class="common-block common-block--empty"></div>
            <!-- Slide navigation -->
              <div class="common-block common-block--grey" :class="{'is-active': aboutSlideNumber === 0}"
                   v-on:click="changeSlide(0, 'about')">
                <h3 class="common-block__title">О нас</h3>
                <!-- <div class="common-block__number">01</div> -->
                <div class="common-block__bottom">
                  <img src="images/pen-icon.svg" alt="icon" class="common-block__icon">
                </div>
              </div>
              <div class="common-block common-block--green" :class="{'is-active': aboutSlideNumber === 1}"
                   v-on:click="changeSlide(1, 'about')">
                <h3 class="common-block__title">Нужен ли мне Croinc?</h3>
                <!-- <div class="common-block__number">02</div> -->
                <div class="common-block__bottom">
                  <img src="images/ok-icon.svg" alt="icon" class="common-block__icon">
                  <img src="images/not-ok-icon.svg" alt="icon" class="common-block__icon">
                </div>
              </div>
              <div class="common-block common-block--red" :class="{'is-active': aboutSlideNumber === 2}"
                   v-on:click="changeSlide(2, 'about')">
                <h3 class="common-block__title">Партнеры</h3>
                <!-- <div class="common-block__number">03</div> -->
                <div class="common-block__bottom">
                  <img src="images/partner-icon.svg" alt="icon" class="common-block__icon">
                </div>
              </div>
          </div>
          <div class="about__blocks-wrapper">
            <swiper :options="landSwOptions" v-show="!mediaDesktop">
              <swiper-slide>
                <div class="common-block common-block--grey slider" :class="{'is-active': aboutSlideNumber === 0}" v-on:click="changeSlide(0, 'about')">
                  <h3 class="common-block__title">О нас</h3>
                  <!-- <div class="common-block__number">01</div> -->
                  <div class="common-block__bottom">
                    <img src="images/pen-icon.svg" alt="icon" class="common-block__icon">
                  </div>
                </div>
              </swiper-slide>

              <swiper-slide>
                <div class="common-block common-block--green slider" :class="{'is-active': aboutSlideNumber === 1}" v-on:click="changeSlide(1, 'about')">
                  <h3 class="common-block__title">Нужен ли мне Croinc?</h3>
                  <!-- <div class="common-block__number">02</div> -->
                  <div class="common-block__bottom">
                    <img src="images/ok-icon.svg" alt="icon" class="common-block__icon">
                    <img src="images/not-ok-icon.svg" alt="icon" class="common-block__icon">
                  </div>
                </div>
              </swiper-slide>

              <swiper-slide>
                <div class="common-block common-block--red slider" :class="{'is-active': aboutSlideNumber === 2}" v-on:click="changeSlide(2, 'about')">
                  <h3 class="common-block__title">Партнеры</h3>
                  <!-- <div class="common-block__number">03</div> -->
                  <div class="common-block__bottom">
                    <img src="images/partner-icon.svg" alt="icon" class="common-block__icon">
                  </div>
                </div>

              </swiper-slide>

            </swiper>
          </div>
        </div>
      </div>
    </section>
    <section class="common-section rates" id="rates-anchor">
      <div class="container">
        <h2 class="common-section__title">Тарифы</h2>
        <div class="rates__wrap">

          <div class="rates__blocks-wrapper" v-if="mediaDesktop">
            <div :class="{'common-block common-block--green': true,  'is-active': tariffSlideNumber === 0}"
                 v-on:click="changeSlide(0, 'tariff')">
              <h3 class="common-block__title">Бюджет</h3>
              <div class="common-block__number">01</div>
            </div>
            <div :class="{'common-block common-block--red': true,  'is-active': tariffSlideNumber === 1}"
                 v-on:click="changeSlide(1, 'tariff')">
              <h3 class="common-block__title">Стандарт
                <span class="top">TOP</span>
              </h3>
              <div class="common-block__number">02</div>
            </div>
            <div class="common-block common-block--dgreen" style="display: none;" >
              <h3 class="common-block__title">Pro
                <span class="soon">Скоро</span>
              </h3>
              <div class="common-block__number">03</div>
            </div>
            <div class="common-block common-block--grey" style="display: none;">
              <h3 class="common-block__title">Свой тариф</h3>
              <div class="common-block__number">04</div>
            </div>
          </div>

          <div class="rates__blocks-wrapper">
            <swiper :options="landSwOptions" v-show="!mediaDesktop">
              <swiper-slide>
                <div :class="{'common-block slider common-block--green': true,  'is-active': tariffSlideNumber === 0}" v-on:click="changeSlide(0, 'tariff')">
                  <h3 class="common-block__title">Бюджет</h3>
                  <div class="common-block__number">01</div>
                </div>
              </swiper-slide>
              <swiper-slide v-on:click="changeSlide(1, 'tariff')">
                <div :class="{'common-block slider common-block--red': true,  'is-active': tariffSlideNumber === 1}" v-on:click="changeSlide(1, 'tariff')">
                  <h3 class="common-block__title">Стандарт
                    <span class="top">TOP</span>
                  </h3>
                  <div class="common-block__number">02</div>
                </div>
              </swiper-slide>
            </swiper>
          </div>


          <div class="rates__info-wrapper">
            <div class="rates__main-slider">
              <div class="rates__slide" v-if="tariffSlideNumber === 0">
                <h2 class="rates__subtitle" >Тариф "Бюджет"</h2>
                <ul class="rates__list">
                  <li class="rates__list-item">1 Филиал (доп.филиал + 200/месяц)</li>
                  <li class="rates__list-item">5 Сотрудников (доп.сотрудник +50 ₽/месяц)</li>
                  <li class="rates__list-item">Отключение сторонней рекламы 35₽/блок (максимум 3 блока)</li>
                  <li class="rates__list-item">Сообщение через SM&Co. 2₽</li>
                  <li class="rates__list-item">Бесплатная рассылка на E-mail</li>
                  <li class="rates__list-item">Минимальная оплата за 3 месяца</li>
                </ul>
                <div class="rates__bottom">
                  <div class="rates__price">300₽/месяц</div>
                  <!--                 <a href="#" class="rates__btn">Настроить тариф</a>-->
                </div>
              </div>
              <div class="rates__slide" v-if="tariffSlideNumber === 1">
                <h2 class="rates__subtitle">Тариф "Стандарт"</h2>
                <ul class="rates__list">
                  <li class="rates__list-item">1 Филиал (доп.филиал + 350₽/месяц)</li>
                  <li class="rates__list-item">7 Сотрудников (доп.сотрудник +50 ₽/месяц)</li>
                  <li class="rates__list-item">Без сторонней рекламы</li>
                  <li class="rates__list-item">Подключение своей 100₽/месяц (максимум 3 блока)</li>
                  <li class="rates__list-item">Сообщение через SM&Co. 2₽</li>
                  <li class="rates__list-item">Бесплатная рассылка на E-mail</li>
                  <li class="rates__list-item">Минимальная оплата за 3 месяца</li>
                </ul>
                <div class="rates__bottom">
                  <div class="rates__price">450₽/месяц</div>
                  <!--                 <a href="#" class="rates__btn">Настроить тариф</a>-->
                </div>
              </div>
              <div class="rates__slide" style="display:none">
                <h2 class="rates__subtitle">Тариф "PRO"</h2>
                <ul class="rates__list">
                  <li class="rates__list-item">1 Филиал</li>
                  <li class="rates__list-item">7 Сотрудников (доп.сотрудник +25 ₽/месяц)</li>
                  <li class="rates__list-item">Блок рекламы 100₽/месяц (максимум 3 блока)</li>
                  <li class="rates__list-item">Сообщение через SM&Co. 2₽</li>
                  <li class="rates__list-item">Бесплатная рассылка на E-mail</li>
                  <li class="rates__list-item">Минимальная оплата за 3 месяца</li>
                </ul>
                <div class="rates__bottom">
                  <div class="rates__price">1300₽/месяц</div>
                  <!--                 <a href="#" class="rates__btn">Настроить тариф</a>-->
                </div>
              </div>
              <div class="rates__slide" style="display:none">
                <h2 class="rates__subtitle">Свой тариф</h2>
                <ul class="rates__list">
                  <li class="rates__list-item">1 Филиал</li>
                  <li class="rates__list-item">7 Сотрудников (доп.сотрудник +25 ₽/месяц)</li>
                  <li class="rates__list-item">Блок рекламы 100₽/месяц (максимум 3 блока)</li>
                  <li class="rates__list-item">Сообщение через SM&Co. 2₽</li>
                  <li class="rates__list-item">Бесплатная рассылка на E-mail</li>
                  <li class="rates__list-item">Минимальная оплата за 3 месяца</li>
                </ul>
                <div class="rates__bottom">
                  <div class="rates__price">3000₽/месяц</div>
                  <!--                 <a href="#" class="rates__btn">Настроить тариф</a>-->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="common-section products" id="products-anchor">
      <div class="container">
        <h2 class="common-section__title">Наши продукты</h2>
        <div class="products__wrap">
          <div class="products__info-wrapper">

            <div class="products__main-slider">

              <div class="products__slide" v-if="productSlide === 0">
                <h2 class="products__subtitle">Система онлайн записи "Croinc"</h2>
                <p class="products__text">"Он-Лайн" запись экономит время вашего клиента, повышает его лояльность к вашим услугам, оптимизирует процессы и сокращает расходы на содержание дополнительного персонала.</p>
                <router-link to="/register" class="products__btn">Зарегистрироваться</router-link>
              </div>
              <div class="products__slide" v-if="productSlide === 1">
                <h2 class="products__subtitle">Администрирование записей</h2>
                <p class="products__text">Больше не нужно вписывать всю информацию в обычный журнал учета, вы сможете вводить ее в наш электронный журнал, при этом она не потеряется и о ней не забудут. Плюс — вы всегда сможете дистанционно проверить работу вашего филиала!</p>
              </div>
              <div class="products__slide" v-if="productSlide === 2">
                <h2 class="products__subtitle">Push уведомления в мессенджерах</h2>
                <p class="products__text">Это запатентованная система отправки сообщений на ваш любимый мессенджер. Как пример если у вас нет Whatsapp, наша система об этом узнает и отправит сообщение на Viber.</p>
              </div>

            </div>
          </div>
          <div class="products__blocks-wrapper" v-if="mediaDesktop">
            <div class="common-block common-block--empty"></div>
            <div :class="{'common-block common-block--blue' : true, 'is-active': productSlide === 0}" v-on:click="changeSlide(0, 'product')">
              <h3 class="common-block__title">Онлайн - запись «Croinc»</h3>
              <div class="common-block__bottom">
                <img src="images/desk-icon.svg" alt="icon" class="common-block__icon">
                <img src="images/mobile-icon.svg" alt="icon" class="common-block__icon">
              </div>
            </div>
            <div :class="{'common-block  common-block--green': true, 'is-active': productSlide === 1}" v-on:click="changeSlide(1, 'product')">
              <h3 class="common-block__title">Электронный журнал</h3>
              <div class="common-block__bottom common-block__bottom--text">
                <p class="common-block__text-item">Имя Фамилия</p>
                <p class="common-block__text-item">+7(ХХХ)ХХХ-ХХ-ХХ</p>
                <p class="common-block__text-item">Наименование услуги</p>
              </div>
            </div>
            <div :class="{'common-block  common-block--red': true, 'is-active': productSlide === 2}" v-on:click="changeSlide(2, 'product')">
              <h3 class="common-block__title">Система оповещений SM&Co.</h3>
              <div class="common-block__bottom">
                <img src="images/whats-icon.svg" alt="icon" class="common-block__icon">
                <img src="images/tg-icon.svg" alt="icon" class="common-block__icon">
                <img src="images/viber-icon.svg" alt="icon" class="common-block__icon">
              </div>
            </div>
          </div>
          <div class="products__blocks-wrapper" v-if="!mediaDesktop">
            <swiper :options="landSwOptions">
              <swiper-slide>
                <div :class="{'common-block slider common-block--blue' : true, 'is-active': productSlide === 0}" v-on:click="changeSlide(0, 'product')">
                  <h3 class="common-block__title">Онлайн - запись «Croinc»</h3>
                  <div class="common-block__bottom">
                    <img src="images/desk-icon.svg" alt="icon" class="common-block__icon">
                    <img src="images/mobile-icon.svg" alt="icon" class="common-block__icon">
                  </div>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div :class="{'common-block slider common-block--green': true, 'is-active': productSlide === 1}" v-on:click="changeSlide(1, 'product')">
                  <h3 class="common-block__title">Электронный журнал</h3>
                  <div class="common-block__bottom common-block__bottom--text">
                    <p class="common-block__text-item">Имя Фамилия</p>
                    <p class="common-block__text-item">+7(ХХХ)ХХХ-ХХ-ХХ</p>
                    <p class="common-block__text-item">Наименование услуги</p>
                  </div>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div :class="{'common-block slider common-block--red': true, 'is-active': productSlide === 2}" v-on:click="changeSlide(2, 'product')">
                  <h3 class="common-block__title">Система оповещений SM&Co.</h3>
                  <div class="common-block__bottom">
                    <img src="images/whats-icon.svg" alt="icon" class="common-block__icon">
                    <img src="images/tg-icon.svg" alt="icon" class="common-block__icon">
                    <img src="images/viber-icon.svg" alt="icon" class="common-block__icon">
                  </div>
                </div>
              </swiper-slide>
            </swiper>
         </div>
        </div>
      </div>
    </section>
  </main>

</template>

<script>
  import 'swiper/dist/css/swiper.css'
  import { swiper, swiperSlide } from 'vue-awesome-swiper'

  export default {
    name: "Landing",
    components: {
      swiper,
      swiperSlide
    },
    data() {
      return {
        aboutSlideNumber: 0,
        aboutSubSlideNumber: 0,
        aboutContent: [
          {
            aboutLinks: ['Салон красоты', 'Фитнесс', 'Ресторан', 'Здоровье', 'Авто-Бизнес']
          },
          {
            aboutContent : [
              'Вы не пропустите ни одного клиента',
              'Ваши клиенты с лёгкостью смогут записаться на тренировку',
              'В любое время у вас смогут забронировать столик',
              'Сделайте запись на консультацию еще проще',
              'Дайте клиенту возможность записаться на любую услугу за секунды'
            ]
          }
        ],
        landSwOptions: {
          slidesPerView: 4,
          spaceBetween: 14,
          breakpoints: {
            1200: {
              slidesPerView: 2
            }
          }
        },
        tariffSlideNumber: 0,
        productSlide: 0
      }
    },
    computed: {
      mediaDesktop() {
        return window.matchMedia( '(min-width:992px)' ).matches;
      }

    },
    methods: {
      changeSlide(num, type) {
        if(type === 'about') {
          this.aboutSlideNumber = num;
        } else if(type === 'subAbout') {
          this.aboutSubSlideNumber = num
        }
        else if(type === 'tariff') {
          this.tariffSlideNumber = num
        }
        else if (type === 'product') {
          this.productSlide = num;
        }

      }
    }
  }
</script>

<style scoped>

</style>
